import SimpleAutocompleteFactory from "components/Autocomplete/SimpleAutocompleteFactory"
import { TransactionFilterNFTValueEnum } from "../../../../../services/api/openapi"

export const NftFilter = SimpleAutocompleteFactory<TransactionFilterNFTValueEnum>({
  allNfts: "All NFTs",
})

export default NftFilter
